import { QueryObserverResult, UseQueryOptions, useQuery } from '@tanstack/react-query';
import { buildParams } from '../../../../api/types/api.types';
import { useRESTFetcher } from '../../../../api/useRESTFetcher';
import { API_URL } from '../../../../config/endpoints';
import { ClientForm, FormVerificationMetadata } from '../types/digitalForms.api.types';

type ClientFormResponse = ClientForm | FormVerificationMetadata;

interface ClientFormQueryProps {
  uuid?: string;
}

export const useClientForm = (op: { opcode: string }, props: ClientFormQueryProps, configProps?: UseQueryOptions<ClientFormResponse | null>): QueryObserverResult<ClientFormResponse | null> => {
  const { koiFetch } = useRESTFetcher();
  const getQuery = async (props: ClientFormQueryProps) => {
    const params = buildParams({
      sets: [{ name: 'uuid', value: props.uuid }],
    });
    return koiFetch(`${API_URL}/forms/clientForm?${params}`, {
      method: 'GET',
    });
  };

  return useQuery<ClientFormResponse | null>({
    queryKey: ['forms/clientForm', props],
    queryFn: () => getQuery(props),
    enabled: props.uuid != null,
    staleTime: Infinity,
    retryDelay: 2000,
    ...configProps,
    throwOnError: () => {
      console.error(`OPCODE: ${op.opcode}`);
      return true;
    },
  });
};
